export default __webpack_public_path__ + "fd18a5fef183906a3259f1201594dd07.svg";